import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "rounded-lg border bg-card text-card-foreground shadow-sm px-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col space-y-1.5 p-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold tracking-tight text-2xl" }, "Credit Box")
], -1)
const _hoisted_3 = { class: "p-6 pt-0 -my-1 text-sm space-y-3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Loan Size: ", -1)
const _hoisted_6 = { class: "text-sky font-semibold" }
const _hoisted_7 = { class: "text-sky font-semibold" }
const _hoisted_8 = { class: "text-sky font-semibold" }
const _hoisted_9 = { class: "text-sky font-semibold" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Execution types:", -1)
const _hoisted_12 = { key: 2 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, " Property types: ", -1)
const _hoisted_14 = { key: 3 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold" }, "Footprint:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.creditBox.AmountRange)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
            _hoisted_5,
            (_ctx.creditBox.AmountRange.MinimumAmount && _ctx.creditBox.AmountRange.MaximumAmount)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(" from "),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.convertToShortCurrency(_ctx.creditBox.AmountRange.MinimumAmount).toUpperCase()), 1),
                  _createTextVNode(" to "),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.convertToShortCurrency(_ctx.creditBox.AmountRange.MaximumAmount).toUpperCase()), 1)
                ], 64))
              : (_ctx.creditBox.AmountRange.MinimumAmount && !_ctx.creditBox.AmountRange.MaximumAmount)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" from "),
                    _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.convertToShortCurrency(_ctx.creditBox.AmountRange.MinimumAmount).toUpperCase()), 1)
                  ], 64))
                : (!_ctx.creditBox.AmountRange.MinimumAmount && _ctx.creditBox.AmountRange.MaximumAmount)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _createTextVNode(" up to "),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.convertToShortCurrency(_ctx.creditBox.AmountRange.MaximumAmount).toUpperCase()), 1)
                    ], 64))
                  : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.executionTypes.displayedTypes)
        ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(_ctx.executionTypes.displayedTypes) + " ", 1),
            (_ctx.executionTypes.toggle)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "#expand",
                  class: "text-sky font-medium",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showModal('ModalPublicCreditBox', { originator: _ctx.originator, creditBox: _ctx.creditBox })), ["prevent"]))
                }, _toDisplayString(_ctx.executionTypes.toggle), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.propertyTypes.displayedTypes)
        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.propertyTypes.displayedTypes) + " ", 1),
            (_ctx.propertyTypes.toggle)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "#expand",
                  class: "text-sky font-medium",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.showModal('ModalPublicCreditBox', { originator: _ctx.originator, creditBox: _ctx.creditBox })), ["prevent"]))
                }, _toDisplayString(_ctx.propertyTypes.toggle), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.footprints.displayedTypes)
        ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
            _hoisted_15,
            _createTextVNode(" " + _toDisplayString(_ctx.footprints.displayedTypes) + " ", 1),
            (_ctx.footprints.toggle)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "#expand",
                  class: "text-sky font-medium",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.showModal('ModalPublicCreditBox', { originator: _ctx.originator, creditBox: _ctx.creditBox })), ["prevent"]))
                }, _toDisplayString(_ctx.footprints.toggle), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}